<template>
    <VueElementLoading spinner="ring" color="#32c54c" :active="props.isActive" :is-full-screen="true"/>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'LoadingComponent',
  components: { VueElementLoading },
  props: ['props'],
  data() {
    return {
      isActive: false
    }
  }
}
</script>
